import { forwardRef, useContext } from "react"

import InputWithUnit from "./InputWithUnit/InputWithUnit"

import { LocalizationContext } from "web/contexts"
import { useUnits } from "web/hooks/data"

const DistanceInput = forwardRef((props, ref) => {
  const { defaultDistanceUnit } = useContext(LocalizationContext)
  const [{ distance_units: distanceUnits }] = useUnits()
  const supportedDistanceUnitCodes = distanceUnits.map((c) => c.code)

  return (
    <InputWithUnit
      ref={ref}
      kind="Distance"
      units={supportedDistanceUnitCodes}
      defaultUnit={defaultDistanceUnit}
      {...props}
    />
  )
})

export default DistanceInput
